//
//
//
//

import { AppMain } from "./components";
export default {
  name: 'Layout2',
  components: {
    AppMain: AppMain
  }
};